import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

Vue.use(VueI18n)

export default new VueI18n({
  locale: (window && window.localStorage && window.localStorage['ma2-chat-fer-locale']) || (navigator.language ? navigator.language.substring(0, 2) : null) || 'en',
  messages
})



// WEBPACK FOOTER //
// ./src/lang/index.js